import React from "react";
import { Reveal } from "./Reveal";
import HeroFrame from "./HeroFrame";

export default function Hero() {
  return (
    <header className="hero" id="top">
      <div className="wrap">
        <Reveal className="hero__copy">
          <div className="hero__hier">Cierge Labs / Journey Storybook</div>
          <div className="eyebrow">KATLAS Authority Journey</div>
          <h1 className="hero__h1">
            One stalled decision.<br />
            One governed route forward.
          </h1>
          <span className="hero__accent" aria-hidden="true" />
          <p className="hero__kicker">
            Across five organisations, each holding a different part of the answer.
          </p>
          <p className="hero__lede">
            When a time-critical exception depends on evidence held by different organisations,
            ordinary systems can show the problem but cannot safely move the decision forward.
          </p>
        </Reveal>
      </div>

      <HeroFrame />
    </header>
  );
}
